module.exports = {"name":"commentAndSubscribe","audiences":["allMembers"],"autoTrack":true,"experimentAllocation":1,"defaultWeight":1,"bucketVersion":"v2","experimentVersion":"v2","defaults":{"enabled":false},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/commentAndSubscribe.json
// module id = Olyv
// module chunks = 0